/*
Placeholder component to use until we transition to MUIv5
*/
import React from 'react';
import { Box } from '@material-ui/core';

export default function Stack({ direction = 'column', children, ...props }) {
    return (
        <Box props style={{display: 'flex', flexDirection : direction}}>
            {children}
        </Box>
    )
    
    
}